module.exports = __webpack_public_path__ + "media/locales/_es-9919ee5e.png";